<template>
    <el-dialog
            custom-class="e6-message-box"
            :title="title"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="450px">
        <slot></slot>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="messageBoxSubmit">确 定</el-button>
            <el-button @click="messageBoxCancel">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "E6MessageBox",
        props: {
            messageBoxVisible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "提示信息"
            }
        },
        computed: {
            dialogVisible: {
                get() {
                    return this.messageBoxVisible;
                },
                set(v) {
                    this.updateMessageBoxVisible(v);
                }
            }
        },
        methods: {
            updateMessageBoxVisible(v) {
                this.$emit("update:messageBoxVisible", v);
            },
            messageBoxSubmit() {
                this.$emit("messageBoxSubmit");
                this.updateMessageBoxVisible(false);
            },
            messageBoxCancel() {
                this.$emit("messageBoxCancel");
                this.updateMessageBoxVisible(false);
            }
        }
    };
</script>
